import { uniqBy } from 'ramda';
// Range windows loaded at different times can hold the same row twice after it moves.
export const getSelectedRows = (rows, isSelected) => uniqBy((row) => row.ipsosId, rows.filter((row) => isSelected(row)));
//# sourceMappingURL=getSelectedRows.js.map